// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__89zt7","qualcommimg":"SponsorsSection_qualcommimg__R9od5"};